
export const CMS_HOST = 'cmsHost'
export const JWT_TOKEN = 'jwtToken'
